import BaseStore from './BaseStore';
import { Record } from 'immutable';
import { ActionTypes } from '../constants/AppConstants';
import t from '../lib/I18n';

const DefaultAmazonPayState = new Record({
  addressConsentToken: null,
  addressError: null,
  amazonOrderReferenceId: null,
  errorText: null,
  errorTimestamp: null,
  errorType: null,
  hasLoginCompleted: false,
  isAmazonMFASuccessful: false,
  isInvalidPaymentMethod: false,
  isProcessing: false
});

export class AmazonPayStore extends BaseStore {
  deserialize(serialized) {
    if (serialized) {
      return new DefaultAmazonPayState({
        addressConsentToken: serialized.addressConsentToken,
        amazonOrderReferenceId: serialized.amazonOrderReferenceId
      });
    }
    return new DefaultAmazonPayState();
  }

  handleAddressError({ countryCode = null }) {
    let newAddressError = null;

    if (countryCode) {
      newAddressError = t('payment.amazonPay.chooseCorrectAddress', { countryCode });
    }
    this.setState(this.state.merge({
      addressError: newAddressError
    }));
  }

  handleClearError() {
    this.setState(this.state.merge({
      errorTimestamp: null
    }));
  }

  handleError({ errorText, errorType }) {
    this.setState(this.state.merge({
      errorText,
      errorTimestamp: Date.now(), // add timestamp to trigger UI update even when errorText didn't change
      errorType,
      isAmazonMFASuccessful: false
    }));
  }

  handleInvalidPaymentMethod({ isInvalidPaymentMethod }) {
    this.setState(this.state.merge({
      hasLoginCompleted: true,
      isInvalidPaymentMethod,
      isProcessing: false
    }));
  }

  handleLoginComplete({ addressConsentToken, hasLoginCompleted }) {
    let clearErrors;

    if (hasLoginCompleted === true) {
      clearErrors = {
        errorText: null,
        errorTimestamp: null,
        errorType: null
      };
    }

    const addressConsentTokenProp = typeof addressConsentToken !== 'undefined' ? { addressConsentToken } : null;

    this.setState(this.state.merge({
      ...addressConsentTokenProp,
      hasLoginCompleted,
      ...clearErrors
    }));
  }

  handleMFASuccessful({ isAmazonMFASuccessful }) {
    this.setState(this.state.merge({
      isAmazonMFASuccessful: isAmazonMFASuccessful
    }));
  }

  handleProcessing({ isProcessing = false, amazonOrderReferenceId }) {
    this.setState(this.state.merge({
      isProcessing,
    }));

    if (amazonOrderReferenceId) {
      this.setState(this.state.merge({
        amazonOrderReferenceId
      }));
    }
  }

  resetAmazonTemporaryFlags() {
    this.setState(this.state.merge({
      addressConsentToken: null,
      addressError: null,
      amazonOrderReferenceId: null,
      errorText: null,
      errorTimestamp: null,
      errorType: null,
      isAmazonMFASuccessful: false,
      isInvalidPaymentMethod: false,
      isProcessing: false
    }));
  }

  getActionHandlers() {
    return {
      [ActionTypes.AMAZON_PAY_ADDRESS_ERROR]: this.handleAddressError,
      [ActionTypes.AMAZON_PAY_CLEAR_ERROR]: this.handleClearError,
      [ActionTypes.AMAZON_PAY_ERROR]: this.handleError,
      [ActionTypes.AMAZON_PAY_INVALID_PAYMENT_METHOD]: this.handleInvalidPaymentMethod,
      [ActionTypes.AMAZON_PAY_LOGIN_COMPLETE]: this.handleLoginComplete,
      [ActionTypes.AMAZON_PAY_LOGOUT]: this.resetState,
      [ActionTypes.AMAZON_PAY_MFA_SUCCESSFUL]: this.handleMFASuccessful,
      [ActionTypes.AMAZON_PAY_PROCESSING]: this.handleProcessing,
      [ActionTypes.LOGGED_OUT]: this.resetState,
      [ActionTypes.PAYMENT_AUTH_RESET]: this.resetAmazonTemporaryFlags,
      [ActionTypes.PAYMENT_AUTH_FINISHED]: this.resetAmazonTemporaryFlags
    };
  }
}

const instance = new AmazonPayStore({ storageKey: 'amazonPay' });

export default instance;



// WEBPACK FOOTER //
// ./src/stores/AmazonPayStore.js